export type ObjectTypesEdgesType = {
  id?: number
  name: string
  from_type_id: number
  to_type_id: number
  table_fields: string[]
  sum_fields: any[]
  cardinality?: string | null
  field_a_id?: string | null
  field_b_id?: string | null
}

export const CardinalityOptions = [
  { value: '', title: 'Без типа связи (PARENT)' },
  { value: 'one_to_one', title: 'Один к одному (1:1)' },
  { value: 'one_to_many', title: 'Один ко многим (1:M)' },
  { value: 'many_to_one', title: 'Многие к одному (M:1)' },
  { value: 'many_to_many', title: 'Многие ко многим (M:M)' },
]
